module.exports = __webpack_public_path__ + "static/media/timer.f55e8349.svg";